import React from 'react';

import AppRouter from './router/AppRouter';
import dva from './utils/dva';
import models from './models/models';
import './utils/bridge';

const app = dva({
  initialState: {},
  models,
  onError: error => {
    console.log(error);
  },
});

export default app.start(<AppRouter />);
